module.exports = function(app) {
    // used to format and display a standardized JSON formatted phone
    app.directive('portalPhones', [function () {
        return {
            restrict: "A",
            replace: true,
			template: "<ul class='portalPhones'>" +
					      "<li data-ng-repeat='phone in phones'>" +
			                  "<span class='number'><span data-ng-if='phone.countryCode != 1'>{{phone.countryCode}} </span>({{phone.areaCode}}) {{phone.cityCode}}-{{phone.numberCode}}</span>" +
			                  "<span class='type'>({{phone.type}})</span>" +
	                      "</li>" +
	                  "</ul>",
            scope: {
                phones: "=portalPhones"
            }
        };
    }]);
};